/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Seite nicht gefunden",
  "ComingSoon": "Demnächst verfügbar",
  "YesanPersonalFinance": "Yesan, Persönliche Finanzen",
  "Yesan": "Yesan",
  "PersonalFinance": "Persönliche Finanzen",
  "YesanDownload": "Yesan herunterladen",
  "ThisWebsiteUsesCookies": "Wir verwenden Cookies, um Informationen über die Leistung und Nutzung unserer Website zu sammeln und zu analysieren und um Funktionen für soziale Medien bereitzustellen. Wenn Sie fortfahren, erklären Sie sich mit der Verwendung von Cookies einverstanden.",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Finanziell frei werden",
  "inStepsAndActions": "in 8 Schritten und 3 Aktionen.",
  "TrackPlanAnalyze": "Verfolgen. Planen. Analysieren.",
  "FTrack": "1. Verfolgen",
  "FPlan": "2. Planen",
  "FAnalyze": "3. Analysieren",
  "Features": "Funktionen",
  "FeaturesSubHeading": "Reine Anfänger, die sich bereits mit Finanzen auskennen - dies ist die App, die Sie brauchen, um finanziell frei zu werden.",
  "ManageAccounts": "Verwalten Sie Konten",
  "CashLiquidFixedAssetsLiabilities": "Bargeld, liquide Mittel, Anlagevermögen und Verbindlichkeiten.",
  "TrackTransactions": "Verfolgen Sie Transaktionen",
  "IncomesExpensesTransferInvestments": "Einnahmen, Ausgaben, Überweisungen, Investitionen.",
  "ImportExport": "Importieren/Exportieren",
  "YourDataAlwaysAccessible": "Ihre Daten immer im Zugriff.",
  "PlanYourFreedom": "Planen Sie Ihre Freiheit",
  "StepsAwayFromFI": "8 Schritte bis zur finanziellen Unabhängigkeit.",
  "BudgetsAndGoals": "Budgets & Ziele",
  "CheckYourProgressAndAchieve": "Überprüfen Sie Ihre Fortschritte und erreichen Sie Ihre finanziellen Ziele.",
  "DashboardAndAnalytics": "Dashboard & Analysen",
  "ReviewLearnOptimizeWith": "Überprüfen, Lernen, Optimieren mit Diagrammen, Einblicken und Tools.",
  "Security": "Sicherheit",
  "MilitaryGradeEncryption": "Militärische Verschlüsselung, Biometrie-Unterstützung, Daten werden auf Ihren Geräten gespeichert.",
  "OfflineMode": "Offline-Modus",
  "YourDataAlwaysAccessibleAndModif": "Ihre Daten sind immer zugänglich und änderbar.",
  "Track": "Verfolgen Sie",
  "Income": "Einnahmen",
  "Expense": "Ausgaben",
  "Transfer": "Übertragen",
  "transactionsAndManageAccounts": "Transaktionen und verwalten Sie eine Vielzahl von Konten:",
  "checkings": "Girokonto",
  "savings": "Sparen",
  "realEstate": "Immobilien",
  "stocks": "Aktienmärkte",
  "bonds": "Anleihen",
  "crypto": "Krypto",
  "notes": "Banknoten, Bargeld Brieftasche",
  "envelopes": "Briefumschläge",
  "privateEquity": "Privates Eigenkapital",
  "metal": "Metall",
  "retirement": "Ruhestand",
  "lifeInsurance": "Lebensversicherung",
  "intellectualProperty": "Geistiges Eigentum",
  "otherLiquidAsset": "Sonstige flüssige Mittel",
  "otherFixedAsset": "Sonstiges Anlagevermögen",
  "mortgage": "Hypothek",
  "loan": "Verbraucherdarlehen",
  "creditCard": "Kreditkarte",
  "otherLiability": "Sonstige Verbindlichkeiten",
  "AccountsManagement": "Verwaltung von Konten",
  "MultipleAccountsTypesAndGrouping": "Mehrere Kontenarten und Gruppierung",
  "LinkAccounts": "Verknüpfen Sie Konten von Ihren Institutionen (nur in bestimmten Ländern verfügbar)",
  "SmartAccounts": "Intelligente Konten",
  "AddEditDeleteTransactions": "Hinzufügen / Bearbeiten / Löschen von Transaktionen",
  "TickVerifiedTransactions": "Verifizierte Transaktionen ankreuzen",
  "CategorizeTransactions": "Transaktionen kategorisieren",
  "TagTransactions": "Transaktionen markieren",
  "TrackKakeiboType": "Kakeibo-Typ verfolgen",
  "TrackInvestments": "Investitionen verfolgen (nur in bestimmten Ländern verfügbar)",
  "ImportFromCSVFile": "Transaktionen vollständig oder schrittweise aus einer CSV-Datei importieren",
  "ExportToCSVFile": "Transaktionen in eine CSV-Datei exportieren",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 Stufen zur finanziellen Unabhängigkeit, detaillierte Budgetplanung, erreichen Sie Ihre finanziellen Ziele schneller.",
  "levelsTowardsFI": "8 Stufen zur finanziellen Unabhängigkeit",
  "EstablishBudgetsPer": "Erstellen Sie Budgets pro",
  "account": "Konto",
  "accountType": "Kontotyp",
  "KakeiboType": "Kakeibo-Typ",
  "category": "Kategorie",
  "tag": "Tag",
  "label": "Etikett",
  "TrackBudgetsPerFrequency": "Budgets pro Frequenz verfolgen",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Ziele für Ausgaben, Saldo, Cashflow und Aktionen erstellen",
  "TrackGoalsProgress": "Verfolgen Sie den Fortschritt der Ziele",
  "ReviewLearnOptimizeWithReportsCharts": "Überprüfen, Lernen, Optimieren mit Berichten, Diagrammen, Trends, Einblicken, Tools.",
  "Dashboard": "Dashboard",
  "FSNetWorth": "Finanzberichte: Nettowert",
  "FSPnL": "Finanzielle Berichte: Erfolgsrechnung / Gewinn & Verlust",
  "FSBalanceSheetAssetsLiabilities": "Jahresabschlüsse: Bilanz, Aktiva, Passiva",
  "FSCashFlow": "Jahresabschlüsse: Kapitalflussrechnung, Soll und Haben, Flüsse",
  "FSFlows": "Jahresabschlüsse: Ströme",
  "FSRatios": "Jahresabschlüsse: Verhältnisse",
  "TrendsMonthEnd": "Trends zum Monatsende: Einnahmen & Ausgaben, Cash Flow",
  "TrendsPerformance": "Leistungstrends: YoY, MoM, WoW",
  "IncomeTrendsPer": "Einkommenstrends pro",
  "SpendingTrendsPer": "Ausgabentrends pro",
  "RecurringItemsIE": "Wiederkehrende Posten: Einnahmen & Ausgaben",
  "DebtProgressTrends": "Schulden Fortschritt Trends",
  "KakeiboMTDReviewTrends": "Kakeibo: MTD Rückblick, letzter Monat, Trends",
  "FIWCLE": "Finanzielle Unabhängigkeit: Wandtafel, Ausgaben nach Lebensenergie",
  "DebtPaydownSnowballAvalanche": "Schuldenabbau: Schneeball, Avalanche",
  "FullyCustomizableAnalyticsRange": "Vollständig anpassbare Analysezeitspanne",
  "ContactUs": "Kontaktieren Sie uns",
  "Privacy": "Datenschutz",
  "Terms": "Begriffe",
  "About": "Über",
  "IAgreeToThe": "Ich akzeptiere die",
  "AndThe": "und der",
  "PrivacyPolicy": "Datenschutzbestimmungen",
  "TermsOfUse": "Nutzungsbedingungen",
  "DigitalSoftwareExperienceTagline": "Digitale Software-Erfahrung für die moderne Welt",
  "DigitalExperience": "Digitale Erfahrung",
  "SoftwareForTheModernWorld": "Software für die moderne Welt",
  "MobileApplications": "Mobile Anwendungen",
  "forConnectedAndOfflineHumans": "für vernetzte und offline Menschen",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Responsive und Webdienste",
  "PersonalFinanceServices": "Persönliche Finanzdienstleistungen",
  "YS_p1": "Yesan ist ein dynamisches Softwareunternehmen, das sich auf die Entwicklung modernster mobiler Anwendungen für Verbraucher spezialisiert hat. Mit einem ausgeprägten Verständnis für die sich entwickelnden Bedürfnisse und Vorlieben der heutigen technikaffinen Nutzer, widmet sich Yesan der Entwicklung intuitiver, ansprechender und funktionsreicher mobiler Anwendungen, die das Leben seiner Nutzer bereichern.",
  "YS_p2": "Der Kern von Yesans Mission ist ein unermüdliches Engagement für Innovation und Kreativität. Jedes Produkt wird sorgfältig entwickelt, um nahtlose Funktionalität und ein außergewöhnliches Benutzererlebnis zu bieten.",
  "PersonalFinanceApplication": "Persönliche Finanzanwendung",
  "YPF_p1": "Yesan, Personal Finance ist eine hochmoderne mobile Finanzanwendung, die den Nutzern umfassende Finanzmanagement-Tools zur Verfügung stellt, auf die sie bequem per Fingertipp zugreifen können. Mit einer schlanken und intuitiven Benutzeroberfläche bietet Yesan, Personal Finance einen ganzheitlichen Ansatz für die Verwaltung von Finanzen und richtet sich an Benutzer mit unterschiedlichen finanziellen Kenntnissen.",
  "YPF_p2": "Zu den wichtigsten Funktionen gehören die Verfolgung des Budgets, die Kategorisierung von Ausgaben und die Überwachung von Transaktionen in Echtzeit, so dass die Nutzer mühelos Einblicke in ihre Ausgabengewohnheiten gewinnen können. Die App bietet auch anpassbare Budgetierungsoptionen, die es den Nutzern ermöglichen, finanzielle Ziele zu setzen und ihre Fortschritte im Laufe der Zeit zu verfolgen.",
  "YPF_p3": "Darüber hinaus legt Yesan, Personal Finance größten Wert auf Sicherheit und verwendet modernste Verschlüsselungsprotokolle, um die sensiblen Finanzdaten der Nutzer zu schützen. Mit Sicherheitsmaßnahmen auf Bankniveau können Benutzer ihre Konten vertrauensvoll verknüpfen und Transaktionen synchronisieren, ohne ihre Privatsphäre zu gefährden.",
  "YPF_p4": "Yesan, Personal Finance geht über die einfache Budgetierung hinaus und bietet aufschlussreiche Analysen und personalisierte Empfehlungen zur Optimierung finanzieller Entscheidungen. Ob es darum geht, potenzielle Sparmöglichkeiten zu identifizieren, Investitionsportfolios zu überwachen oder Strategien zur Schuldentilgung zu verwalten, die App bietet maßgeschneiderte Einblicke, die dem Nutzer helfen, seine finanziellen Ziele zu erreichen.",
  "Discover": "Entdecken Sie",
  "Firstname": "Vorname",
  "Lastname": "Nachname",
  "Company":"Bedrijf",
  "Subject": "Betreff",
  "Email": "E-Mail",
  "Message": "Nachricht",
  "ThankYouForContactingUs": "Vielen Dank für Ihre Kontaktaufnahme",
  "ValidFirstnameRequired": "Ein gültiger Vorname ist erforderlich.",
  "ValidLastnameRequired": "Gültiger Nachname ist erforderlich.",
  "ValidEmailAddressRequired": "Bitte geben Sie eine gültige E-Mail Adresse ein.",
  "ValidSubjectRequired": "Bitte wählen Sie einen gültigen Betreff.",
  "ValidMessageRequired": "Bitte geben Sie eine gültige Nachricht ein.",
  "UnableToSendTheFormPleaseRetryLater": "Das Formular kann nicht gesendet werden. Bitte versuchen Sie es später erneut.",
  "Information": "Informationen",
  "Sales":"Vertrieb",
  "Support": "Unterstützung",
  "Press": "Presse",
  "Partnership": "Partnerschaft",
  "Other": "Andere",
  "Blog":"Blog",

  "Accept":"Akzeptieren",
  "Decline":"Ablehnen",

  "WorklogCalendar":"Worklog Kalender für Jira",

  "DirectlyAccessibleInProjectApps":"Direkter Zugriff in Projektanwendungen",
  "VisualizeWhereYouSpentYourTime":"Visualisieren Sie, wo Sie Ihre Zeit verbracht haben",
  "AllYourWorklogsInACalendar":"Alle Ihre Arbeitsprotokolle in einem Kalender",
  "MonthSummary":"Monatsübersicht",
  "CheckIfYouForgotToLogTime":"Prüfen Sie, ob Sie vergessen haben, Zeit zu erfassen.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Direkter Zugriff auf die Aufgaben und Aktualisierung der Zeit",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Klicken Sie auf den Eintrag im Arbeitsprotokoll, um direkt auf die Aufgaben zuzugreifen und Ihre erfasste Zeit zu bearbeiten",
  "AlsoAvailableInDarkMode":"Auch im dunklen Modus verfügbar",
  "DirectlyLogWorkOnTheCalendarVisually":"Arbeiten direkt im Kalender visuell protokollieren",
  "ClickOnTheCalendarToCreateNewWorklog":"Klicken Sie auf den Kalender, um ein neues Arbeitsprotokoll zu erstellen",

  "AppsForAtlassian":"Anwendungen für Atlassian",
  "YCL_p1":"Visualisieren Sie alle Ihre Worklogs in einem Kalender mit Monats-, Wochen-, Arbeitswochen- und Tagesansichten.",
  "YCL_p2":"Erfassen Sie die Arbeit direkt im Kalender, indem Sie das Zeitfenster visuell auswählen.",
  "YCL_p3":"Erkennen Sie, wenn Sie vergessen haben, die Zeit für Ihre Stundenzettel zu erfassen.",
  "YCL_p4":"Verfügbar in Ihrer Sprache: Englisch (UK), Englisch (US), Chinesisch (vereinfacht), Chinesisch (traditionell), Tschechisch, Dänisch, Niederländisch, Estnisch, Finnisch, Französisch, Deutsch, Ungarisch, Isländisch, Italienisch, Japanisch, Koreanisch, Norwegisch, Polnisch, Portugiesisch (Brasilien), Portugiesisch (Portugal), Russisch, Spanisch, Schwedisch, Türkisch.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Finanzportfolio für Jira",
  "BringRealFinancialPortfolio":"Erweitern Sie Jira um echtes Finanzportfoliomanagement. Verfolgen Sie Budgets, CapEx/OpEx und Projektkosten an einem Ort.",
  "YFPAboutQ":"Wie viel kosten uns unsere Jira-Projekte wirklich?",
  "YFPAbout":"Finanzportfolio für Jira\nFinanzverantwortliche und PMOs tun sich schwer, eine einfache Frage zu beantworten:\nWie viel kosten uns unsere Jira-Projekte wirklich?\nJira erfasst die Arbeit.\nDie Finanzabteilung erfasst die Budgets.\nDiese App verbindet endlich beides.\n\nFinancial Portfolio verwandelt Jira in eine schlanke PPM- und Finanzplanungsplattform – ganz ohne teure Unternehmens-Tools.",
  "YFPPorfolioQ":"Portfolio-Budgets & Nachverfolgung",
  "YFPPorfolioP":"Erstellen Sie Portfolios über mehrere Jira-Projekte hinweg und definieren Sie: Budgetbetrag, Währung, Datumsbereich, enthaltene Projekte, Teams. Verfolgen Sie die Ist-Kosten automatisch, während die Arbeit in Jira erfolgt.",
  "YFPPorfolioListQ":"Portfolios",
  "YFPPorfolioListP":"Erstellen Sie Finanzportfolios, die mehrere Jira-Projekte kombinieren, und sehen Sie sofort: Budget vs. Ist-Kosten, Projekt-Burn-Rate in Echtzeit, Aufschlüsselung nach CapEx und OpEx, Kosten pro Issue und Projekt, exportierbare Finanzberichte. Alles direkt auf Basis der Jira-Arbeitsprotokolle.",
  "CostQ":"Automatische Kostenberechnung",
  "CostP":"Verwandeln Sie Zeiterfassung in echte Finanzdaten. Die App: Liest Jira-Arbeitsprotokolle, wendet Stundensätze an, berechnet täglich die tatsächlichen Projektkosten. Keine Tabellenkalkulationen. Keine manuelle Arbeit.",
  "RatesQ":"Sätze",
  "RatesP":"Stundensätze pro Projekt, Team oder global festlegen",
  "ReportQ":"Finanzberichte im CSV-Format",
  "ReportP":"Portfolio-Finanzdaten in Sekundenschnelle exportieren. Ideal für: Finanzteams, CFO-Berichterstattung, Budgetplanung, Unterstützung bei der Wirtschaftsprüfung",
  "SettingsQ":"CapEx- vs. OpEx-Klassifizierung",
  "SettingsP":"Unterstützt Anforderungen der Buchhaltung und Wirtschaftsprüfung. Klassifizieren Sie Arbeiten in: aktivierbare Entwicklung (CapEx), operative Arbeit (OpEx). Erstellen Sie exportierbare Berichte, die für Finanzteams bereit sind."
};

export const documents = {
};
